<div class="page-inner">
  <img src="assets/images/earth.jpg" alt="" class="img-responsive">
</div>
<div class="container error-404">
  <router-outlet></router-outlet>
</div>
